/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginRouteImport } from './routes/login'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as AuthenticatedPlaygroundRouteImport } from './routes/_authenticated/playground'
import { Route as AuthenticatedRpmBenchRouteImport } from './routes/_authenticated/rpm-bench'
import { Route as AuthenticatedSummariesRouteImport } from './routes/_authenticated/summaries'
import { Route as AuthenticatedVitalsEntryRouteImport } from './routes/_authenticated/vitals-entry'
import { Route as AuthenticatedWorklistRouteImport } from './routes/_authenticated/worklist'
import { Route as AuthenticatedAdminBandSetsRouteImport } from './routes/_authenticated/admin/band-sets'
import { Route as AuthenticatedAdminCareUnitsRouteImport } from './routes/_authenticated/admin/care-units'
import { Route as AuthenticatedAdminFacilityRoutingRouteImport } from './routes/_authenticated/admin/facility-routing'
import { Route as AuthenticatedAdminFacilityZonesRouteImport } from './routes/_authenticated/admin/facility-zones'
import { Route as AuthenticatedAdminMessageContentRouteImport } from './routes/_authenticated/admin/message-content'
import { Route as AuthenticatedAdminOnboardingRouteImport } from './routes/_authenticated/admin/onboarding'
import { Route as AuthenticatedAdminPracticeConfigurationsRouteImport } from './routes/_authenticated/admin/practice-configurations'
import { Route as AuthenticatedAdminReadinessRouteImport } from './routes/_authenticated/admin/readiness'
import { Route as AuthenticatedAdminRolesRouteImport } from './routes/_authenticated/admin/roles'
import { Route as AuthenticatedAdminRoutingDirectoryRouteImport } from './routes/_authenticated/admin/routing-directory'
import { Route as AuthenticatedAdminRoutingImportRouteImport } from './routes/_authenticated/admin/routing-import'
import { Route as AuthenticatedAdminSourceSystemsRouteImport } from './routes/_authenticated/admin/source-systems'
import { Route as AuthenticatedAdminStandingCopiesRouteImport } from './routes/_authenticated/admin/standing-copies'
import { Route as AuthenticatedAdminVitalDefinitionsRouteImport } from './routes/_authenticated/admin/vital-definitions'
import { Route as AuthenticatedPlatformIndexRouteImport } from './routes/_authenticated/platform/index'
import { Route as AuthenticatedSummariesSummaryIdRouteImport } from './routes/_authenticated/summaries_.$summaryId'
import { Route as AuthenticatedPlatformEntriesEntryIdRouteImport } from './routes/_authenticated/platform/entries.$entryId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedPlaygroundRoute = AuthenticatedPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRpmBenchRoute = AuthenticatedRpmBenchRouteImport.update({
  id: '/rpm-bench',
  path: '/rpm-bench',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSummariesRoute = AuthenticatedSummariesRouteImport.update({
  id: '/summaries',
  path: '/summaries',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVitalsEntryRoute =
  AuthenticatedVitalsEntryRouteImport.update({
    id: '/vitals-entry',
    path: '/vitals-entry',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorklistRoute = AuthenticatedWorklistRouteImport.update({
  id: '/worklist',
  path: '/worklist',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminBandSetsRoute =
  AuthenticatedAdminBandSetsRouteImport.update({
    id: '/admin/band-sets',
    path: '/admin/band-sets',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminCareUnitsRoute =
  AuthenticatedAdminCareUnitsRouteImport.update({
    id: '/admin/care-units',
    path: '/admin/care-units',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminFacilityRoutingRoute =
  AuthenticatedAdminFacilityRoutingRouteImport.update({
    id: '/admin/facility-routing',
    path: '/admin/facility-routing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminFacilityZonesRoute =
  AuthenticatedAdminFacilityZonesRouteImport.update({
    id: '/admin/facility-zones',
    path: '/admin/facility-zones',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminMessageContentRoute =
  AuthenticatedAdminMessageContentRouteImport.update({
    id: '/admin/message-content',
    path: '/admin/message-content',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminOnboardingRoute =
  AuthenticatedAdminOnboardingRouteImport.update({
    id: '/admin/onboarding',
    path: '/admin/onboarding',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminPracticeConfigurationsRoute =
  AuthenticatedAdminPracticeConfigurationsRouteImport.update({
    id: '/admin/practice-configurations',
    path: '/admin/practice-configurations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminReadinessRoute =
  AuthenticatedAdminReadinessRouteImport.update({
    id: '/admin/readiness',
    path: '/admin/readiness',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminRolesRoute = AuthenticatedAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoutingDirectoryRoute =
  AuthenticatedAdminRoutingDirectoryRouteImport.update({
    id: '/admin/routing-directory',
    path: '/admin/routing-directory',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminRoutingImportRoute =
  AuthenticatedAdminRoutingImportRouteImport.update({
    id: '/admin/routing-import',
    path: '/admin/routing-import',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminSourceSystemsRoute =
  AuthenticatedAdminSourceSystemsRouteImport.update({
    id: '/admin/source-systems',
    path: '/admin/source-systems',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminStandingCopiesRoute =
  AuthenticatedAdminStandingCopiesRouteImport.update({
    id: '/admin/standing-copies',
    path: '/admin/standing-copies',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminVitalDefinitionsRoute =
  AuthenticatedAdminVitalDefinitionsRouteImport.update({
    id: '/admin/vital-definitions',
    path: '/admin/vital-definitions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlatformIndexRoute =
  AuthenticatedPlatformIndexRouteImport.update({
    id: '/platform/',
    path: '/platform/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSummariesSummaryIdRoute =
  AuthenticatedSummariesSummaryIdRouteImport.update({
    id: '/summaries_/$summaryId',
    path: '/summaries/$summaryId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlatformEntriesEntryIdRoute =
  AuthenticatedPlatformEntriesEntryIdRouteImport.update({
    id: '/platform/entries/$entryId',
    path: '/platform/entries/$entryId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/two-factor': typeof TwoFactorRoute
  '/playground': typeof AuthenticatedPlaygroundRoute
  '/rpm-bench': typeof AuthenticatedRpmBenchRoute
  '/summaries': typeof AuthenticatedSummariesRoute
  '/vitals-entry': typeof AuthenticatedVitalsEntryRoute
  '/worklist': typeof AuthenticatedWorklistRoute
  '/admin/band-sets': typeof AuthenticatedAdminBandSetsRoute
  '/admin/care-units': typeof AuthenticatedAdminCareUnitsRoute
  '/admin/facility-routing': typeof AuthenticatedAdminFacilityRoutingRoute
  '/admin/facility-zones': typeof AuthenticatedAdminFacilityZonesRoute
  '/admin/message-content': typeof AuthenticatedAdminMessageContentRoute
  '/admin/onboarding': typeof AuthenticatedAdminOnboardingRoute
  '/admin/practice-configurations': typeof AuthenticatedAdminPracticeConfigurationsRoute
  '/admin/readiness': typeof AuthenticatedAdminReadinessRoute
  '/admin/roles': typeof AuthenticatedAdminRolesRoute
  '/admin/routing-directory': typeof AuthenticatedAdminRoutingDirectoryRoute
  '/admin/routing-import': typeof AuthenticatedAdminRoutingImportRoute
  '/admin/source-systems': typeof AuthenticatedAdminSourceSystemsRoute
  '/admin/standing-copies': typeof AuthenticatedAdminStandingCopiesRoute
  '/admin/vital-definitions': typeof AuthenticatedAdminVitalDefinitionsRoute
  '/summaries/$summaryId': typeof AuthenticatedSummariesSummaryIdRoute
  '/platform/': typeof AuthenticatedPlatformIndexRoute
  '/platform/entries/$entryId': typeof AuthenticatedPlatformEntriesEntryIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/two-factor': typeof TwoFactorRoute
  '/playground': typeof AuthenticatedPlaygroundRoute
  '/rpm-bench': typeof AuthenticatedRpmBenchRoute
  '/summaries': typeof AuthenticatedSummariesRoute
  '/vitals-entry': typeof AuthenticatedVitalsEntryRoute
  '/worklist': typeof AuthenticatedWorklistRoute
  '/admin/band-sets': typeof AuthenticatedAdminBandSetsRoute
  '/admin/care-units': typeof AuthenticatedAdminCareUnitsRoute
  '/admin/facility-routing': typeof AuthenticatedAdminFacilityRoutingRoute
  '/admin/facility-zones': typeof AuthenticatedAdminFacilityZonesRoute
  '/admin/message-content': typeof AuthenticatedAdminMessageContentRoute
  '/admin/onboarding': typeof AuthenticatedAdminOnboardingRoute
  '/admin/practice-configurations': typeof AuthenticatedAdminPracticeConfigurationsRoute
  '/admin/readiness': typeof AuthenticatedAdminReadinessRoute
  '/admin/roles': typeof AuthenticatedAdminRolesRoute
  '/admin/routing-directory': typeof AuthenticatedAdminRoutingDirectoryRoute
  '/admin/routing-import': typeof AuthenticatedAdminRoutingImportRoute
  '/admin/source-systems': typeof AuthenticatedAdminSourceSystemsRoute
  '/admin/standing-copies': typeof AuthenticatedAdminStandingCopiesRoute
  '/admin/vital-definitions': typeof AuthenticatedAdminVitalDefinitionsRoute
  '/summaries/$summaryId': typeof AuthenticatedSummariesSummaryIdRoute
  '/platform': typeof AuthenticatedPlatformIndexRoute
  '/platform/entries/$entryId': typeof AuthenticatedPlatformEntriesEntryIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/two-factor': typeof TwoFactorRoute
  '/_authenticated/playground': typeof AuthenticatedPlaygroundRoute
  '/_authenticated/rpm-bench': typeof AuthenticatedRpmBenchRoute
  '/_authenticated/summaries': typeof AuthenticatedSummariesRoute
  '/_authenticated/vitals-entry': typeof AuthenticatedVitalsEntryRoute
  '/_authenticated/worklist': typeof AuthenticatedWorklistRoute
  '/_authenticated/admin/band-sets': typeof AuthenticatedAdminBandSetsRoute
  '/_authenticated/admin/care-units': typeof AuthenticatedAdminCareUnitsRoute
  '/_authenticated/admin/facility-routing': typeof AuthenticatedAdminFacilityRoutingRoute
  '/_authenticated/admin/facility-zones': typeof AuthenticatedAdminFacilityZonesRoute
  '/_authenticated/admin/message-content': typeof AuthenticatedAdminMessageContentRoute
  '/_authenticated/admin/onboarding': typeof AuthenticatedAdminOnboardingRoute
  '/_authenticated/admin/practice-configurations': typeof AuthenticatedAdminPracticeConfigurationsRoute
  '/_authenticated/admin/readiness': typeof AuthenticatedAdminReadinessRoute
  '/_authenticated/admin/roles': typeof AuthenticatedAdminRolesRoute
  '/_authenticated/admin/routing-directory': typeof AuthenticatedAdminRoutingDirectoryRoute
  '/_authenticated/admin/routing-import': typeof AuthenticatedAdminRoutingImportRoute
  '/_authenticated/admin/source-systems': typeof AuthenticatedAdminSourceSystemsRoute
  '/_authenticated/admin/standing-copies': typeof AuthenticatedAdminStandingCopiesRoute
  '/_authenticated/admin/vital-definitions': typeof AuthenticatedAdminVitalDefinitionsRoute
  '/_authenticated/summaries_/$summaryId': typeof AuthenticatedSummariesSummaryIdRoute
  '/_authenticated/platform/': typeof AuthenticatedPlatformIndexRoute
  '/_authenticated/platform/entries/$entryId': typeof AuthenticatedPlatformEntriesEntryIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/two-factor'
    | '/playground'
    | '/rpm-bench'
    | '/summaries'
    | '/vitals-entry'
    | '/worklist'
    | '/admin/band-sets'
    | '/admin/care-units'
    | '/admin/facility-routing'
    | '/admin/facility-zones'
    | '/admin/message-content'
    | '/admin/onboarding'
    | '/admin/practice-configurations'
    | '/admin/readiness'
    | '/admin/roles'
    | '/admin/routing-directory'
    | '/admin/routing-import'
    | '/admin/source-systems'
    | '/admin/standing-copies'
    | '/admin/vital-definitions'
    | '/summaries/$summaryId'
    | '/platform/'
    | '/platform/entries/$entryId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/two-factor'
    | '/playground'
    | '/rpm-bench'
    | '/summaries'
    | '/vitals-entry'
    | '/worklist'
    | '/admin/band-sets'
    | '/admin/care-units'
    | '/admin/facility-routing'
    | '/admin/facility-zones'
    | '/admin/message-content'
    | '/admin/onboarding'
    | '/admin/practice-configurations'
    | '/admin/readiness'
    | '/admin/roles'
    | '/admin/routing-directory'
    | '/admin/routing-import'
    | '/admin/source-systems'
    | '/admin/standing-copies'
    | '/admin/vital-definitions'
    | '/summaries/$summaryId'
    | '/platform'
    | '/platform/entries/$entryId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/two-factor'
    | '/_authenticated/playground'
    | '/_authenticated/rpm-bench'
    | '/_authenticated/summaries'
    | '/_authenticated/vitals-entry'
    | '/_authenticated/worklist'
    | '/_authenticated/admin/band-sets'
    | '/_authenticated/admin/care-units'
    | '/_authenticated/admin/facility-routing'
    | '/_authenticated/admin/facility-zones'
    | '/_authenticated/admin/message-content'
    | '/_authenticated/admin/onboarding'
    | '/_authenticated/admin/practice-configurations'
    | '/_authenticated/admin/readiness'
    | '/_authenticated/admin/roles'
    | '/_authenticated/admin/routing-directory'
    | '/_authenticated/admin/routing-import'
    | '/_authenticated/admin/source-systems'
    | '/_authenticated/admin/standing-copies'
    | '/_authenticated/admin/vital-definitions'
    | '/_authenticated/summaries_/$summaryId'
    | '/_authenticated/platform/'
    | '/_authenticated/platform/entries/$entryId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  TwoFactorRoute: typeof TwoFactorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/playground': {
      id: '/_authenticated/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof AuthenticatedPlaygroundRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/rpm-bench': {
      id: '/_authenticated/rpm-bench'
      path: '/rpm-bench'
      fullPath: '/rpm-bench'
      preLoaderRoute: typeof AuthenticatedRpmBenchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/summaries': {
      id: '/_authenticated/summaries'
      path: '/summaries'
      fullPath: '/summaries'
      preLoaderRoute: typeof AuthenticatedSummariesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vitals-entry': {
      id: '/_authenticated/vitals-entry'
      path: '/vitals-entry'
      fullPath: '/vitals-entry'
      preLoaderRoute: typeof AuthenticatedVitalsEntryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/worklist': {
      id: '/_authenticated/worklist'
      path: '/worklist'
      fullPath: '/worklist'
      preLoaderRoute: typeof AuthenticatedWorklistRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/band-sets': {
      id: '/_authenticated/admin/band-sets'
      path: '/admin/band-sets'
      fullPath: '/admin/band-sets'
      preLoaderRoute: typeof AuthenticatedAdminBandSetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/care-units': {
      id: '/_authenticated/admin/care-units'
      path: '/admin/care-units'
      fullPath: '/admin/care-units'
      preLoaderRoute: typeof AuthenticatedAdminCareUnitsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/facility-routing': {
      id: '/_authenticated/admin/facility-routing'
      path: '/admin/facility-routing'
      fullPath: '/admin/facility-routing'
      preLoaderRoute: typeof AuthenticatedAdminFacilityRoutingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/facility-zones': {
      id: '/_authenticated/admin/facility-zones'
      path: '/admin/facility-zones'
      fullPath: '/admin/facility-zones'
      preLoaderRoute: typeof AuthenticatedAdminFacilityZonesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/message-content': {
      id: '/_authenticated/admin/message-content'
      path: '/admin/message-content'
      fullPath: '/admin/message-content'
      preLoaderRoute: typeof AuthenticatedAdminMessageContentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/onboarding': {
      id: '/_authenticated/admin/onboarding'
      path: '/admin/onboarding'
      fullPath: '/admin/onboarding'
      preLoaderRoute: typeof AuthenticatedAdminOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/practice-configurations': {
      id: '/_authenticated/admin/practice-configurations'
      path: '/admin/practice-configurations'
      fullPath: '/admin/practice-configurations'
      preLoaderRoute: typeof AuthenticatedAdminPracticeConfigurationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/readiness': {
      id: '/_authenticated/admin/readiness'
      path: '/admin/readiness'
      fullPath: '/admin/readiness'
      preLoaderRoute: typeof AuthenticatedAdminReadinessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/roles': {
      id: '/_authenticated/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AuthenticatedAdminRolesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/routing-directory': {
      id: '/_authenticated/admin/routing-directory'
      path: '/admin/routing-directory'
      fullPath: '/admin/routing-directory'
      preLoaderRoute: typeof AuthenticatedAdminRoutingDirectoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/routing-import': {
      id: '/_authenticated/admin/routing-import'
      path: '/admin/routing-import'
      fullPath: '/admin/routing-import'
      preLoaderRoute: typeof AuthenticatedAdminRoutingImportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/source-systems': {
      id: '/_authenticated/admin/source-systems'
      path: '/admin/source-systems'
      fullPath: '/admin/source-systems'
      preLoaderRoute: typeof AuthenticatedAdminSourceSystemsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/standing-copies': {
      id: '/_authenticated/admin/standing-copies'
      path: '/admin/standing-copies'
      fullPath: '/admin/standing-copies'
      preLoaderRoute: typeof AuthenticatedAdminStandingCopiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/vital-definitions': {
      id: '/_authenticated/admin/vital-definitions'
      path: '/admin/vital-definitions'
      fullPath: '/admin/vital-definitions'
      preLoaderRoute: typeof AuthenticatedAdminVitalDefinitionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/platform/': {
      id: '/_authenticated/platform/'
      path: '/platform'
      fullPath: '/platform/'
      preLoaderRoute: typeof AuthenticatedPlatformIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/summaries_/$summaryId': {
      id: '/_authenticated/summaries_/$summaryId'
      path: '/summaries/$summaryId'
      fullPath: '/summaries/$summaryId'
      preLoaderRoute: typeof AuthenticatedSummariesSummaryIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/platform/entries/$entryId': {
      id: '/_authenticated/platform/entries/$entryId'
      path: '/platform/entries/$entryId'
      fullPath: '/platform/entries/$entryId'
      preLoaderRoute: typeof AuthenticatedPlatformEntriesEntryIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedPlaygroundRoute: typeof AuthenticatedPlaygroundRoute
  AuthenticatedRpmBenchRoute: typeof AuthenticatedRpmBenchRoute
  AuthenticatedSummariesRoute: typeof AuthenticatedSummariesRoute
  AuthenticatedVitalsEntryRoute: typeof AuthenticatedVitalsEntryRoute
  AuthenticatedWorklistRoute: typeof AuthenticatedWorklistRoute
  AuthenticatedAdminBandSetsRoute: typeof AuthenticatedAdminBandSetsRoute
  AuthenticatedAdminCareUnitsRoute: typeof AuthenticatedAdminCareUnitsRoute
  AuthenticatedAdminFacilityRoutingRoute: typeof AuthenticatedAdminFacilityRoutingRoute
  AuthenticatedAdminFacilityZonesRoute: typeof AuthenticatedAdminFacilityZonesRoute
  AuthenticatedAdminMessageContentRoute: typeof AuthenticatedAdminMessageContentRoute
  AuthenticatedAdminOnboardingRoute: typeof AuthenticatedAdminOnboardingRoute
  AuthenticatedAdminPracticeConfigurationsRoute: typeof AuthenticatedAdminPracticeConfigurationsRoute
  AuthenticatedAdminReadinessRoute: typeof AuthenticatedAdminReadinessRoute
  AuthenticatedAdminRolesRoute: typeof AuthenticatedAdminRolesRoute
  AuthenticatedAdminRoutingDirectoryRoute: typeof AuthenticatedAdminRoutingDirectoryRoute
  AuthenticatedAdminRoutingImportRoute: typeof AuthenticatedAdminRoutingImportRoute
  AuthenticatedAdminSourceSystemsRoute: typeof AuthenticatedAdminSourceSystemsRoute
  AuthenticatedAdminStandingCopiesRoute: typeof AuthenticatedAdminStandingCopiesRoute
  AuthenticatedAdminVitalDefinitionsRoute: typeof AuthenticatedAdminVitalDefinitionsRoute
  AuthenticatedSummariesSummaryIdRoute: typeof AuthenticatedSummariesSummaryIdRoute
  AuthenticatedPlatformIndexRoute: typeof AuthenticatedPlatformIndexRoute
  AuthenticatedPlatformEntriesEntryIdRoute: typeof AuthenticatedPlatformEntriesEntryIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedPlaygroundRoute: AuthenticatedPlaygroundRoute,
  AuthenticatedRpmBenchRoute: AuthenticatedRpmBenchRoute,
  AuthenticatedSummariesRoute: AuthenticatedSummariesRoute,
  AuthenticatedVitalsEntryRoute: AuthenticatedVitalsEntryRoute,
  AuthenticatedWorklistRoute: AuthenticatedWorklistRoute,
  AuthenticatedAdminBandSetsRoute: AuthenticatedAdminBandSetsRoute,
  AuthenticatedAdminCareUnitsRoute: AuthenticatedAdminCareUnitsRoute,
  AuthenticatedAdminFacilityRoutingRoute:
    AuthenticatedAdminFacilityRoutingRoute,
  AuthenticatedAdminFacilityZonesRoute: AuthenticatedAdminFacilityZonesRoute,
  AuthenticatedAdminMessageContentRoute: AuthenticatedAdminMessageContentRoute,
  AuthenticatedAdminOnboardingRoute: AuthenticatedAdminOnboardingRoute,
  AuthenticatedAdminPracticeConfigurationsRoute:
    AuthenticatedAdminPracticeConfigurationsRoute,
  AuthenticatedAdminReadinessRoute: AuthenticatedAdminReadinessRoute,
  AuthenticatedAdminRolesRoute: AuthenticatedAdminRolesRoute,
  AuthenticatedAdminRoutingDirectoryRoute:
    AuthenticatedAdminRoutingDirectoryRoute,
  AuthenticatedAdminRoutingImportRoute: AuthenticatedAdminRoutingImportRoute,
  AuthenticatedAdminSourceSystemsRoute: AuthenticatedAdminSourceSystemsRoute,
  AuthenticatedAdminStandingCopiesRoute: AuthenticatedAdminStandingCopiesRoute,
  AuthenticatedAdminVitalDefinitionsRoute:
    AuthenticatedAdminVitalDefinitionsRoute,
  AuthenticatedSummariesSummaryIdRoute: AuthenticatedSummariesSummaryIdRoute,
  AuthenticatedPlatformIndexRoute: AuthenticatedPlatformIndexRoute,
  AuthenticatedPlatformEntriesEntryIdRoute:
    AuthenticatedPlatformEntriesEntryIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  TwoFactorRoute: TwoFactorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
